function initiateInventoryStep(inventories) {
  return inventories || null;
}

export { initiateInventoryStep };
